import { render, staticRenderFns } from "./ListaVentasPedidos.vue?vue&type=template&id=f8b67a72&"
import script from "./ListaVentasPedidos.vue?vue&type=script&lang=js&"
export * from "./ListaVentasPedidos.vue?vue&type=script&lang=js&"
import style0 from "./ListaVentasPedidos.vue?vue&type=style&index=0&id=f8b67a72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports